import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import StopWout from '../WordPr/StopWout';
import PythonSc from '../WordPr/PythonSc';
import ProcLibraryAns from '../WordPr/ProcLibraryAns';
import stringSimilarity from 'string-similarity-js';
import AnswerALoaderStyle from '../styles&pics/AnswerALoaderStyle';
import Answer from './Answer';
import TypingText from '../UtilityComponents/TypingText';
import CommonWords from '../WordPr/CommonWords';
import { apiScoreCode } from '../../api';

function countWords(str) {
  const REGEX = /[\w'-]+|[\u0370-\u03FF']+/gi;
  const wordsArray = str.match(REGEX) || [];
  return wordsArray.filter(word => word.trim() !== '').length;
}

export default function AnswerLoader() {
  const { state } = useLocation();
  const answer     = state ? state.answerText : '';
  const userAnswer = state ? state.useranswer : '';
  const answerCode = state ? state.answerCode : '';
  const userCode   = state ? state.usercode   : '';
  const userImg    = state ? state.userimg    : '';

  const [codeScore,      setCodeScore]      = useState(0);
  const [codeScoreReady, setCodeScoreReady] = useState(false);

  const hasCode = userCode && userCode !== '' && answerCode && answerCode !== '';

  useEffect(() => {
    if (hasCode) {
      apiScoreCode(userCode, answerCode)
        .then(data => {
          console.log('AI score response:', data);
          setCodeScore(typeof data.score === 'number' ? data.score : 0);
          setCodeScoreReady(true);
        })
        .catch(err => {
          console.error('AI score error:', err);
          setCodeScore(0);
          setCodeScoreReady(true);
        });
    } else {
      setCodeScoreReady(true);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Text scoring (synchronous)
  let textScore = 0;
  let picScore  = 0;
  let p = 0;
  let c = hasCode ? 1 : 0;
  let s = 0;

  if (userAnswer && userAnswer !== '' && answer && answer !== '') {
    const avgWords = (countWords(userAnswer) + countWords(answer)) / 2;
    let check = false;
    let perc  = 0;

    if (avgWords <= 20) {
      [check, perc] = CommonWords({ st1: answer, st2: userAnswer });
      if (check) {
        const Pyth = PythonSc({ st1: answer, st2: userAnswer });
        const Lisc = ProcLibraryAns({ st1: answer, st2: userAnswer });
        const strng = stringSimilarity(answer, userAnswer, 2, true);
        textScore = (Pyth + Lisc + strng) / 3;
      }
    } else {
      const filteredAnswer     = StopWout({ inputString: answer });
      const filteredUserAnswer = StopWout({ inputString: userAnswer });
      [check, perc] = CommonWords({ st1: answer, st2: userAnswer });
      if (check) {
        const Pyth = PythonSc({ st1: filteredAnswer, st2: filteredUserAnswer });
        const Lisc = ProcLibraryAns({ st1: filteredAnswer, st2: filteredUserAnswer });
        const strng = stringSimilarity(filteredAnswer, filteredUserAnswer, 2, true);
        textScore = (Pyth + Lisc + strng) / 3;
      }
    }
    p = 1;
  }

  let totalScore = 0;
  if (codeScoreReady) {
    const denom = p + c + s;
    totalScore = denom > 0 ? (textScore + codeScore + picScore) / denom : 0;
  }

  console.log('textScore:', textScore, 'codeScore:', codeScore, 'totalScore:', totalScore, 'ready:', codeScoreReady);

  return (
    <>
      <AnswerALoaderStyle />
      <main className="answer-main">
        <div className="answer-container">
          {!codeScoreReady || isNaN(textScore)
            ? (
              <div className="loader-wrapper">
                <p className="loader-text"><TypingText text="Η απάντηση διορθώνεται..." /></p>
              </div>
            )
            : (
              <div className="answer-card">
                <Answer
                  totalScore={totalScore}
                  userAnswer={userAnswer}
                  answer={answer}
                  answerCode={answerCode}
                  userCode={userCode}
                  userImg={userImg}
                />
              </div>
            )
          }
        </div>
      </main>
    </>
  );
}
